export var convertToBase64 = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = function (error) { return reject(error); };
    });
};
export var convertBase64ToFile = function (base64, fileName, mimeType) {
    var byteCharacters = atob(base64.split(',')[1]);
    var byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map(function (_, i) { return byteCharacters.charCodeAt(i); });
    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
};
